<form novalidate [formGroup]="plexForm">
  <div class="form-group" style="padding-left:30px; width:33%">
    <div style="padding-top:10px;padding-bottom:30px" class="flex-column">

      <div class="dp-label">Water Type</div>
      <kendo-combobox class="cem-kd-combo form-control" formControlName="WaterType" style="min-width:180px"
        [data]="dWaterType"
        [textField]="'Description'"
        [valueField]="'WaterTypeId'"
        [placeholder]="'Select Water Type...'">
      </kendo-combobox>

      <div class="dp-label">Standard Size</div>
      <kendo-combobox class="cem-kd-combo form-control" formControlName="PondSize" style="min-width:180px"
        [data]="dPondSize"
        [textField]="'Description'"
        [valueField]="'PondSizeId'"
        [placeholder]="'Select Size...'">
      </kendo-combobox>

      <div class="dp-label">Liner Type</div>
      <kendo-combobox class="cem-kd-combo form-control" formControlName="LinerType" style="min-width:180px"
        [data]="dLinerType"
        [textField]="'Description'"
        [valueField]="'LinerTypeId'"
        [placeholder]="'Select Liner Type...'">
      </kendo-combobox>

      <div class="dp-label">Fence Type</div>
      <kendo-combobox class="cem-kd-combo form-control" formControlName="FenceType" style="min-width:180px"
        [data]="dFenceType"
        [textField]="'Description'"
        [valueField]="'FenceTypeId'"
        [placeholder]="'Select Fence Type...'">
      </kendo-combobox>

      <div class="dp-label">Permit Type</div>
      <kendo-combobox class="cem-kd-combo form-control" formControlName="PermitType" style="min-width:180px"
        [data]="dPermitType"
        [textField]="'Name'"
        [valueField]="'PermitTypeId'"
        [placeholder]="'Select Permit Type...'">
      </kendo-combobox>

    </div>
  </div>
</form>